import React, { useState, useEffect } from 'react';
import { Menu, X, ArrowRight } from 'lucide-react';
import { brandData } from '../data/mock';

const Header = ({ onRequestQuote }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', href: '#home' },
    { name: 'Products', href: '#products' },
    { name: 'Capabilities', href: '#capabilities' },
    { name: 'Quality', href: '#quality' },
    { name: 'About', href: '#about' },
    { name: 'Contact', href: '#contact' }
  ];

  const scrollToSection = (href) => {
    setMobileMenuOpen(false);
    if (href === '#home') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <>
      <header 
        className="navigation-header"
        style={{ 
          boxShadow: scrolled ? '0 2px 20px rgba(0,0,0,0.06)' : 'none'
        }}
      >
        <div className="container">
          <div className="flex items-center justify-between">
            <button 
              onClick={() => scrollToSection('#home')}
              className="navigation-logo bg-transparent border-none cursor-pointer"
            >
              {brandData.brand_name}
            </button>

            {/* Desktop Navigation */}
            <nav className="desktop-nav flex items-center gap-8">
              {navLinks.map((link) => (
                <button
                  key={link.name}
                  onClick={() => scrollToSection(link.href)}
                  className="navigation-link bg-transparent border-none cursor-pointer"
                >
                  {link.name}
                </button>
              ))}
              <button 
                className="btn-primary ml-4"
                onClick={onRequestQuote}
              >
                Request Quote
                <ArrowRight size={14} />
              </button>
            </nav>

            {/* Mobile CTA + Menu */}
            <div className="flex items-center gap-4 lg:hidden">
              <button 
                className="btn-primary"
                onClick={onRequestQuote}
                style={{ padding: '10px 16px', fontSize: '12px' }}
              >
                Quote
              </button>
              <button
                className="mobile-menu-toggle"
                onClick={() => setMobileMenuOpen(true)}
                aria-label="Open menu"
              >
                <Menu size={24} color="var(--text-primary)" />
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu">
          <button
            className="mobile-menu-close"
            onClick={() => setMobileMenuOpen(false)}
            aria-label="Close menu"
          >
            <X size={24} color="var(--text-primary)" />
          </button>
          <nav className="mobile-menu-links">
            {navLinks.map((link) => (
              <button
                key={link.name}
                onClick={() => scrollToSection(link.href)}
                className="mobile-menu-link bg-transparent border-none text-left cursor-pointer w-full"
              >
                {link.name}
              </button>
            ))}
          </nav>
          <button 
            className="btn-primary mt-8 w-full"
            onClick={() => {
              setMobileMenuOpen(false);
              onRequestQuote();
            }}
          >
            Request a Quote
            <ArrowRight size={14} />
          </button>
        </div>
      )}
    </>
  );
};

export default Header;
